module.exports = __webpack_public_path__ + "static/frontpage-hero-background-1600-0850715f1ed9a9c86e702cb72157596e.jpg";